import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import DatePicker from "../datepicker/ModalDatePicker";
import Modalstyle from "./modal.module.scss";
import privateAxios from "../../utils/axiosPrivate";
import { sanitizeInput, showToast } from "../../utils/utils";
import { buttonName, InvoiceDetails } from "../../locales/en";
import { getQuoteFeeEditjustmentsUrl } from "../../utils/constants/apiEndPoints";
import { showToastType } from "../../utils/constants/appConstants";
import CommonModal from "./CommonModal";
import ErrorBoundary from "../error-boundary";
import ModalFallback from "../error-boundary/fallback/ModalFallback";
import { getFeeAdjusmentData } from "../../redux/invoiceDetailsSlice";
import { useDispatch } from "react-redux";

export const FeeEditModal = ({
  isOpen,
  toggle,
  sendID,
  sendtrue,
  setSendtrue,
  quoteID
}) => {
  const dispatch = useDispatch();
  const initialFeeAddData = {
    quoteId: "",
    feeCharged: "",
    comment: "",
    completedAt: ""
  };

  const [feeAddData, setFeeAddData] = useState(initialFeeAddData);
  const [errors, setErrors] = useState({});

  const loadFeeEditData = useCallback(async () => {
    try {
      const response = await privateAxios.get(
        getQuoteFeeEditjustmentsUrl(sendID)
      );
      if (response.status === 200) {
        setFeeAddData(response.data.data);
      }
    } catch (error) {
      showToast(error.response?.data?.message, showToastType.error);
    } finally {
      setSendtrue(false);
    }
  }, [sendID, setSendtrue]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFeeAddData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleDateChange = (date) => {
    setFeeAddData((prevState) => ({
      ...prevState,
      completedAt: date
    }));
  };

  const validate = () => {
    const tempErrors = {};
    if (!feeAddData.feeCharged)
      tempErrors.feeCharged = "This field is required.";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  useEffect(() => {
    if (isOpen && sendtrue) {
      loadFeeEditData();
    }
  }, [loadFeeEditData, sendtrue, isOpen]);

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      const dataToSend = {
        quoteId: feeAddData.quoteId,
        feeCharged: feeAddData.feeCharged,
        comment: sanitizeInput(feeAddData.comment),
        completedAt: feeAddData.completedAt
      };

      const response = await privateAxios.put(
        getQuoteFeeEditjustmentsUrl(sendID),
        dataToSend
      );
      if (response.status === 200) {
        await dispatch(getFeeAdjusmentData(quoteID)).unwrap();
        showToast(response.data.message, showToastType.success);
        toggle();
      }
    } catch (error) {
      showToast(error.response?.data?.message, showToastType.error);
    }
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={InvoiceDetails?.feeSection?.feeAddModal.title}
      bodyClassName={Modalstyle.commentModalWrap}
      footerButtons={[
        {
          label: buttonName.close,
          className: "btn btn-secondary",
          onClick: toggle
        },
        {
          label: buttonName.save,
          className: "btn btn-primary",
          onClick: handleSubmit
        }
      ]}
    >
      <ErrorBoundary fallback={<ModalFallback fixHeight="250px" />}>
        <div className="row">
          <div className="mb-3">
            <div className={Modalstyle.modalInputwrap}>
              <label htmlFor="FEE" className="form-label">
                {InvoiceDetails.feeSection.feeAddModal.adjustmentAmount}
              </label>
              <div className={Modalstyle.formInput}>
                <input
                  id="FEE"
                  type="number"
                  value={feeAddData.feeCharged}
                  name="feeCharged"
                  onChange={handleInputChange}
                />
                {errors.feeCharged && (
                  <div className="text-danger small">{errors.feeCharged}</div>
                )}
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className={Modalstyle.modalInputwrap}>
              <label htmlFor="date" className="form-label">
                {InvoiceDetails.paymentSection.paymentModal.th1}
              </label>
              <div className={Modalstyle.formInput}>
                <DatePicker
                  value={feeAddData.completedAt}
                  onChange={handleDateChange}
                />
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className={Modalstyle.modalInputwrap}>
              <label htmlFor="comments" className="form-label">
                {InvoiceDetails.feeSection.feeAddModal.comments}
              </label>
              <div className={Modalstyle.formInput}>
                <textarea
                  id="comments"
                  value={feeAddData.comment}
                  name="comment"
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    </CommonModal>
  );
};

FeeEditModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  sendID: PropTypes.any,
  sendtrue: PropTypes.bool.isRequired,
  setSendtrue: PropTypes.func.isRequired,
  quoteID: PropTypes.any
};

export default FeeEditModal;
